// src/questionnaire/FullQuestionnaireLeftNav.js
import React from "react";
import { useTeamContext } from "../TeamContext";

function FullQuestionnaireLeftNav({ steps, currentIndex, visited, onStepClick }) {
    return (
        <div style={{
            padding: "16px",
            borderRight: "1px solid #ccc",
            cursor: "pointer",
            color: "#28435a"
        }}>
            {steps.map((step, i) => {
                const isCompleted = visited[i];
                // active => brand orange #ea7a0a
                // completed => #707070 (a neutral gray)
                // default => #28435a
                let color;
                if (i === currentIndex) {
                    color = "#ea7a0a";
                } else if (isCompleted) {
                    color = "#707070";
                } else {
                    color = "#28435a";
                }

                return (
                    <div
                        key={step.id}
                        onClick={() => onStepClick(i)}
                        style={{
                            color,
                            marginBottom: "8px",
                            fontSize: "14px",
                            transition: "color 0.2s ease"
                        }}
                    >
                        {i + 1}. {step.title}{" "}
                        {isCompleted && <span style={{ color: "#22cb4d", marginLeft: "4px" }}>✔</span>}
                    </div>
                );
            })}
        </div>
    );
}

export default FullQuestionnaireLeftNav;
